'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var EvaluationIcon = require('./EvaluationIcon.js');
var Typography = require('../../../../../common/components/Typography.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const EvaluationItemStyled = styled__default["default"].div.withConfig({
  componentId: "sc-dms4ch-0"
})(["display:grid;grid-template-columns:max-content auto;gap:0.25rem;align-items:baseline;"]);
const EvaluationItem = _ref => {
  let {
    action,
    message
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(EvaluationItemStyled, null, /*#__PURE__*/React__default["default"].createElement(EvaluationIcon["default"], {
    action: action
  }), /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, message));
};

exports["default"] = EvaluationItem;
